import {camelCaseObjectKeys, onStatus, shimJson} from './helpers'
import {monolithPost} from './fetch'

export const calculateRentToKeepPurchaseTotals = (payload) =>
  monolithPost('/v1/rent-to-keep/purchase-totals', payload).then(
    onStatus({OK: shimJson(camelCaseObjectKeys)}),
  )

export const purchaseRentToKeepItems = (payload) =>
  monolithPost('/v1/checkouts/rent-to-keep', payload).then(
    onStatus({OK: shimJson(camelCaseObjectKeys)}),
  )
